export const CHECK_TYPES = [
  {
    name: "validity",
    label: "Validity Score",
    description:
      "The extent to which all required data is present. Missing values or incomplete records can indicate low quality.",
  },
  {
    name: "completeness",
    label: "Completeness Score",
    description:
      "The data should conform to the defined rules and constraints (e.g., date formats, numeric ranges).",
  },
  {
    name: "outliers",
    label: "Outliers Score",
    description: "data points that differ significantly from other observations in a dataset.",
  },
];

export const DEFAULT_STATE = {
  [CHECK_TYPES[1].name]: {
    data: {},
    loading: true,
    score: 0,
  },
  [CHECK_TYPES[2].name]: {
    data: {},
    loading: true,
    score: 0,
  },
};
